import { Component, OnInit } from '@angular/core';
import { PermissionFacade } from 'app/shared/services/facades/permission.facade';
import { PermissionsNavigatorHelper } from 'app/permissions/permissions-navigator-helper';
import { Permission } from 'app/shared/models/permission';

@Component({
  selector: 'app-permissions-details',
  templateUrl: './permission-details.component.html',
})
export class PermissionDetailsComponent implements OnInit {
  currentItem: Permission = new Permission();

  tabLabels: { permissionSetCount: number; rolesCount: number; usersCount: number } = {
    permissionSetCount: undefined,
    rolesCount: undefined,
    usersCount: undefined,
  } as any;
  canManage = true;

  constructor(public navigatorHelper: PermissionsNavigatorHelper, public permissionFacade: PermissionFacade) {}

  ngOnInit(): void {}

  onClose(): void {
    this.navigatorHelper.back();
  }

  onItemChanged(event: Permission): void {
    this.currentItem = event;
  }

  changeTabLabel(tab: string, amount: number): void {
    this.tabLabels[tab] = amount;
  }
}
